export const OG_IMAGE = '/brand-pages/about/opengraph-about.jpg';
